import React, { useState, useEffect } from "react";
import { Link } from "react-scroll";
import logo from "../assets/logo.jpg";

const Navbar = () => {
	const [scrolled, setScrolled] = useState(false);
	const [menuOpen, setMenuOpen] = useState(false);

	useEffect(() => {
		const handleScroll = () => {
			setScrolled(window.scrollY > 50);
		};
		window.addEventListener("scroll", handleScroll);
		return () => window.removeEventListener("scroll", handleScroll);
	}, []);

	const toggleMenu = () => {
		setMenuOpen(!menuOpen);
	};

	return (
		<nav className={`navbar ${scrolled ? "navbar-scrolled" : ""}`}>
			<div className="nav-container">
				<img
					src={logo}
					alt="Logo"
					className="site-logo"
				/>

				{/* Hamburger Icon - visible on mobile */}
				<div className="hamburger" onClick={toggleMenu}>
					<span
						className={
							menuOpen ? "open" : ""
						}
					></span>
					<span
						className={
							menuOpen ? "open" : ""
						}
					></span>
					<span
						className={
							menuOpen ? "open" : ""
						}
					></span>
				</div>

				<ul
					className={`nav-links ${menuOpen ? "active" : ""}`}
				>
					{[
						"home",
						"about",
						"services",
						"contact",
					].map((section) => (
						<li key={section}>
							<Link
								to={section}
								smooth={true}
								duration={500}
								offset={-70}
								onClick={() =>
								setMenuOpen(
									false,
								)
							}
							>
								{section
									.charAt(
										0,
									)
									.toUpperCase() +
									section.slice(
										1,
									)}
							</Link>
						</li>
					))}
				</ul>
			</div>
		</nav>
	);
};

export default Navbar;
